<style lang="less" scoped>
  @import "../vars.less";

  .layout {
    position: relative;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .header-placement,
  .footer-placement {
    height: 50px;
    flex: none;
  }
  .footer-placement {
    height: 50px;
  }
  .header {
    // position: fixed;
    // top: 0;
    // left: 0;
    height: 50px;
    width: 100%;
    padding-left: @space-normal;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: @background-color;
    z-index: 1;
  }
  .logo {
    height: 16px;
  }
  .header-right {
    height: 100%;
    padding: 0 @space-normal 0 18px;
    display: flex;
    align-items: center;
  }
  .bell {
    height: 24px;
    filter: saturate(0%);
  }
  .disabled {
    filter: grayscale(100%);
    color: @text-color-third !important;
  }
</style>
<style lang="less">
  @import "../vars.less";
  .active-action {
    color: @primary-color;
  }
  .van-tabbar-item__icon {
    font-size: auto;
  }
</style>

<template>
  <page-container :safe-area-inset-bottom="false">
    <div class="header" slot="header">
      <img class="logo" src="/images/logo.svg" />
      <div class="header-right" @click="onMessageBoxClick">
        <img class="bell" src="/images/bell.svg" />
      </div>
    </div>
    <router-view />
    <van-tabbar slot="footer" route :fixed="false" safe-area-inset-bottom>
      <van-tabbar-item replace name="home" :to="{ name: 'home' }">
        <span>{{ $t('首页') }}</span>
        <template #icon="props">
          <img :src="props.active ? '/images/tabbar-icons/home.svg' : '/images/tabbar-icons/home-o.svg'" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="order"
        :class="isOrderRoute ? 'van-tabbar-item--active' : ''"
        @click.native="handleOrderClick" @touchend.native.stop @click.native.stop>
        <span>{{ $t('我的订单') }}</span>
        <template #icon>
          <van-popover placement="top"
            v-model="showOrderPopover"
            :actions="orderLinks"
            @select="go2OrderPage">
            <template #reference>
              <img :src="isOrderRoute ? '/images/tabbar-icons/orders.svg' : '/images/tabbar-icons/orders-o.svg'" />
            </template>
          </van-popover>
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace name="customer" :class="{ disabled: !$auth('SICustomer_DBQuery') }"
        :to="$auth('SICustomer_DBQuery') ? { name: 'customer' } : undefined">
        <span>{{ $t('我的客户') }}</span>
        <template #icon="props">
          <img :src="props.active
              ? '/images/tabbar-icons/customers.svg'
              : '/images/tabbar-icons/customers-o.svg'"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="care" :class="isCareRoute ? 'van-tabbar-item--active' : ''" @click.native="handleCareClick" @touchend.native.stop @click.native.stop>
        <span>{{ $t('客户关怀') }}</span>
        <template #icon>
          <van-popover placement="top"
            v-model="showCarePopover"
            :actions="careLinks"
            @select="go2CarePage">
            <template #reference>
              <img :src="isCareRoute ? '/images/tabbar-icons/care.svg' : '/images/tabbar-icons/care-o.svg'" />
            </template>
          </van-popover>
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace name="profile" :to="{ name: 'profile' }">
        <span>{{ $t('我的') }}</span>
        <template #icon="props">
          <img :src="props.active ? '/images/tabbar-icons/profile.svg' : '/images/tabbar-icons/profile-o.svg'" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </page-container>
</template>

<script>
import { Tabbar, TabbarItem, Popover } from 'vant'
import PageContainer from '../components/PageContainer'

export default {
  name: 'layout',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [PageContainer.name]: PageContainer,
    'van-popover': Popover
  },
  data () {
    return {
      activeIndex: 'home',
      showCarePopover: false,
      showOrderPopover: false,
      prevActiveIndex: ''
    }
  },
  computed: {
    careLinks () {
      return [
        {
          text: this.$t('订单加急'),
          name: 'urgent-order',
          className: this.$route.name === 'urgent-order' ? 'active-action' : '',
          disabled: !this.$auth('GreenChannelUrgentOrder')
        },
        {
          text: this.$t('特殊发货'),
          name: 'special-delivery',
          className: this.$route.name === 'special-delivery' ? 'active-action' : '',
          disabled: !this.$auth('SpecialLogistics')
        }
      ]
    },
    orderLinks () {
      return [
        {
          text: this.$t('订单查询'),
          name: 'order',
          className: this.$route.name === 'order' ? 'active-action' : '',
          disabled: !this.$auth('Order')
        },
        {
          text: this.$t('物流查询'),
          name: 'logistics',
          className: this.$route.name === 'logistics' ? 'active-action' : '',
          disabled: !this.$auth('OutBoundLogistics')
        },
        {
          text: this.$t('库存查询'),
          name: 'stock',
          className: this.$route.name === 'stock' ? 'active-action' : '',
          disabled: !this.$auth('Stock')
        }
      ]
    },
    isCareRoute () {
      return this.careLinks.some(link => link.name === this.$route.name)
    },
    isOrderRoute () {
      return this.orderLinks.some(link => link.name === this.$route.name)
    }
  },
  watch: {
    // showCarePopover (v) {
    //   this.prevActiveIndex = this.activeIndex
    //   if (!v) {
    //     if (this.isCareRoute) {
    //       this.activeIndex = 'care'
    //     } else {
    //       this.activeIndex = this.prevActiveIndex
    //       // this.prevActiveIndex = ''
    //     }
    //   }
    // },
    // showOrderPopover (v) {
    //   this.prevActiveIndex = this.activeIndex
    //   if (this.isOrderRoute) {
    //     this.activeIndex = 'order'
    //   } else {
    //     this.activeIndex = this.prevActiveIndex
    //     // this.prevActiveIndex = ''
    //   }
    // }
  },
  methods: {
    onMessageBoxClick () {
      console.log('message box clicked')
    },
    handleCareClick () {
      this.showCarePopover = !this.showCarePopover
    },
    handleOrderClick () {
      this.showOrderPopover = !this.showOrderPopover
    },
    go2CarePage (link) {
      if (this.activeIndex !== 'care') this.activeIndex = 'care'
      this.$route.name !== link.name && this.$router.replace({ name: link.name })
    },
    go2OrderPage (link) {
      if (this.activeIndex !== 'order') this.activeIndex = 'order'
      this.$route.name !== link.name && this.$router.replace({ name: link.name })
    }
  },
  mounted () {
    if (this.isCareRoute) {
      this.activeIndex = 'care'
    }
    if (this.isOrderRoute) {
      this.activeIndex = 'order'
    }
    this.closePopover = () => {
      this.showCarePopover = false
      this.showOrderPopover = false
    }
    document.body.addEventListener('touchend', this.closePopover)
  },
  beforeDestroy () {
    document.body.removeEventListener('touchend', this.closePopover)
  }
}
</script>
